/* @flow */
import Chat from 'entities/Chat';
import { capitalize } from 'lodash';

export default function(chat: Chat, userId: Backbone$Id): string {
  const memberships = chat.getOtherPresentMemberships(Number(userId));

  if (chat.getType() !== 'assistant') {
    if (memberships.length > 1) {
      return memberships.length + 1 + ' people in this conversation';
    } else if (memberships.length === 1) {
      const firstUserRole = memberships[0].getMember().getRole();
      return firstUserRole ? capitalize(firstUserRole) : 'No Role';
    }
  }

  return '';
}
